import { IdAssetBundleProductionAnims } from "./IdAssetBundleProductionAnims";
export var artConfigProductionsOverrides = {
    windmill1: [
        [
            {
                anims: [[], ["windmill blades"], []],
                id: IdAssetBundleProductionAnims.WindmillBlades,
                offset: [95, -75],
                scale: 0.42,
            },
        ],
    ],
    windmill2: [
        [
            {
                anims: [[], ["windmill blades"], []],
                id: IdAssetBundleProductionAnims.WindmillBlades,
                offset: [95, -80],
                scale: 0.42,
            },
        ],
    ],
    windmill3: [
        [
            {
                anims: [[], ["windmill blades"], []],
                id: IdAssetBundleProductionAnims.WindmillBlades,
                offset: [95, -105],
                scale: 0.42,
            },
        ],
    ],
    windmill4: [
        [
            {
                anims: [[], ["windmill blades"], []],
                id: IdAssetBundleProductionAnims.WindmillBlades,
                offset: [95, -125],
                scale: 0.42,
            },
        ],
    ],
    windmill5: [
        [
            {
                anims: [[], ["windmill blades"], []],
                id: IdAssetBundleProductionAnims.WindmillBlades,
                offset: [95, -155],
                scale: 0.42,
            },
        ],
    ],
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/artConfigProductionsOverrides.ts
// module id = 2187
// module chunks = 3